import { useEffect, useState } from "react";
import { X, BadgePercent } from "lucide-react";
import { Link } from "react-router-dom";

const KEY = "je_promo_seen_v1";

export default function OfferPopup() {
  const [open, setOpen] = useState(false);
  useEffect(() => {
    if (sessionStorage.getItem(KEY)) return;
    const t = setTimeout(() => setOpen(true), 2500);
    return () => clearTimeout(t);
  }, []);
  const close = () => { setOpen(false); sessionStorage.setItem(KEY, "1"); };
  if (!open) return null;
  return (
    <div className="fixed inset-0 z-[60] bg-black/60 flex items-center justify-center p-4" onClick={close} data-testid="offer-popup">
      <div className="bg-white rounded-2xl shadow-2xl max-w-md w-full overflow-hidden" onClick={(e)=>e.stopPropagation()}>
        <div className="bg-gradient-to-br from-[#E3000F] to-[#B3000C] text-white p-8 text-center relative">
          <button onClick={close} aria-label="Fermer" className="absolute top-3 right-3 text-white/80 hover:text-white"><X className="w-5 h-5" /></button>
          <BadgePercent className="w-12 h-12 mx-auto mb-3" />
          <p className="text-xs uppercase tracking-[0.3em] font-bold">Offre exclusive</p>
          <h2 className="text-3xl font-extrabold mt-2" style={{fontFamily:"Outfit"}}>Promotions actives</h2>
          <p className="text-white/85 mt-2 text-sm">Découvrez nos meilleures offres du moment sur l'électronique, le solaire et l'électroménager !</p>
        </div>
        <div className="p-6 text-center">
          <Link onClick={close} to="/products?category=promotions" className="je-btn-primary inline-block w-full" data-testid="offer-cta">Voir les promos</Link>
          <button onClick={close} className="mt-3 text-sm text-gray-500 hover:text-gray-700">Continuer la navigation</button>
        </div>
      </div>
    </div>
  );
}
